import { Counter } from '../../Counter'
import { useSelectContext } from '../Select.hooks'

import * as styles from './SelectControlSelectedItemsCounter.module.css'

/**
 * Select control selected items counter should be used only in multi select.
 */
function SelectControlSelectedItemsCounter({
  className = styles.SelectControlSelectedItemsCounter,
}) {
  const { value } = useSelectContext()

  return Array.isArray(value) ? (
    <Counter className={className} count={value.length} />
  ) : null
}

export default SelectControlSelectedItemsCounter
